export function Zoom() {
  return (
    <svg
      width="32"
      height="9"
      viewBox="0 0 32 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_181_23425)">
        <path
          d="M6.717 8.00799H1.02175C0.648753 8.00799 0.284815 7.8078 0.11194 7.47118C-0.0881221 7.07999 -0.0154346 6.61599 0.293878 6.31574L4.26063 2.34912H1.41294C0.630503 2.34912 0.00275292 1.71224 0.00275292 0.938867H5.25225C5.62525 0.938867 5.98913 1.13905 6.162 1.47568C6.36219 1.86687 6.28938 2.33087 5.98007 2.63105L2.01338 6.5978H5.29775C6.08013 6.5978 6.717 7.23468 6.717 8.00799ZM29.2614 0.838867C28.4427 0.838867 27.7148 1.19368 27.2053 1.75774C26.6959 1.19368 25.968 0.838867 25.1493 0.838867C23.639 0.838867 22.4017 2.13074 22.4017 3.64099V8.00799C23.1841 8.00799 23.8118 7.37112 23.8118 6.5978V3.63193C23.8118 2.90405 24.3759 2.28543 25.1037 2.25818C25.8679 2.23087 26.4957 2.84037 26.4957 3.59549V6.5978C26.4957 7.38024 27.1326 8.00799 27.9059 8.00799V3.6228C27.9059 2.89499 28.4699 2.2763 29.1978 2.24905C29.962 2.22174 30.5898 2.8313 30.5898 3.58643V6.58868C30.5898 7.37118 31.2266 7.99887 31.9999 7.99887V3.63199C32.009 2.13074 30.7717 0.838867 29.2614 0.838867ZM13.8497 4.47799C13.8497 6.48862 12.2212 8.11712 10.2106 8.11712C8.19994 8.11712 6.57144 6.48862 6.57144 4.47799C6.57144 2.46737 8.19994 0.838867 10.2106 0.838867C12.2212 0.838867 13.8497 2.46737 13.8497 4.47799ZM12.4395 4.47799C12.4395 3.2498 11.4388 2.24905 10.2106 2.24905C8.98238 2.24905 7.98157 3.2498 7.98157 4.47799C7.98157 5.70624 8.98238 6.70699 10.2106 6.70699C11.4388 6.70699 12.4395 5.70624 12.4395 4.47799ZM21.692 4.47799C21.692 6.48862 20.0635 8.11712 18.0529 8.11712C16.0423 8.11712 14.4138 6.48862 14.4138 4.47799C14.4138 2.46737 16.0423 0.838867 18.0529 0.838867C20.0635 0.838867 21.6921 2.46737 21.6921 4.47799M20.2819 4.47799C20.2819 3.2498 19.2812 2.24905 18.0529 2.24905C16.8248 2.24905 15.824 3.2498 15.824 4.47799C15.824 5.70624 16.8248 6.70699 18.0529 6.70699C19.2812 6.70699 20.2819 5.70624 20.2819 4.47799Z"
          fill="#0B5CFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_181_23425">
          <rect
            width="32"
            height="7.3125"
            fill="white"
            transform="translate(0 0.838867)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
